<template>
	<div>
		<div class="ui placeholder segment">
			<h2 class="ui center aligned icon header">
				<i class="circular clipboard list icon"></i>
				<div v-show="!sinExamenAsignado" class="content">
					{{ nombreExamen }}
					<div class="sub header">{{ fechaInicioLetras }}</div>
					<div class="sub header" style="padding: 1em; text-align: justify">
						<base-mostrar-markdown :contenido="introduccionExamen" />
					</div>
				</div>
				<div v-show="sinExamenAsignado" class="content">
					NO CUENTA CON EXAMEN ASIGNADO
					<div class="sub header"
						>Favor de comunicarse con el personal encargado de la
						institución.</div
					>
				</div>
			</h2>
			<div
				v-show="!sinExamenAsignado && !finalizoExamen"
				class="ui animated button secondary"
				tabindex="0"
				@click="handleIniciar"
			>
				<div class="visible content">Iniciar</div>
				<div class="hidden content">
					<i class="right arrow icon"></i>
				</div>
			</div>
			<div
				v-show="!sinExamenAsignado && finalizoExamen"
				class="ui blue message"
				style="text-align: center"
			>
				<div class="header">{{
					getMensajeTerminado || '¡Examen terminado!'
				}}</div>
				<p v-show="getObservacionTerminado">
					{{ getObservacionTerminado }}
				</p>
			</div>
			<br />
			<sui-button
				v-if="!sinExamenAsignado && finalizoExamen"
				primary
				content="Descargar constancia"
				:loading="getExamenAspiranteLoading"
				:disabled="getExamenAspiranteLoading"
				icon="download"
				style="max-width: inherit;"
				@click="onConstancia"
			/>
			<!-- <sui-button
				class="primary"
				floated="right"
				content="Resultados"
				@click="onResultados"
			/> -->
		</div>
		<BaseModalPoliticasPrivacidad
			ref="modalPolitica"
			:loading="getLoading"
			@guardar="actualizarPoliticas"
		></BaseModalPoliticasPrivacidad>
	</div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import screenfull from 'screenfull';
import moment from 'moment';
import Notification from '../../../utils/notification';
export default {
	data() {
		return {
			nombreExamen: '',
			introduccionExamen: '',
			fechaYHoraInicio: '',
			sinExamenAsignado: false,
			aceptoTerminosYCondiciones: false,
			fechaInicioLetras: '',
			examenFinalizado: false,
			examenIniciado: false,
			totalPreguntas: 0
		};
	},
	computed: {
		...mapGetters('oidc', ['oidcUser']),
		...mapGetters('sidebar', ['getExamen']),
		...mapGetters('aspirantes', ['getLoading']),
		...mapGetters('configuraciones', [
			'getEnableFullScreen',
			'getMensajeTerminado',
			'getObservacionTerminado',
			'getEnableCameraRecorder',
			'getEnableScreenRecorder'
		]),
		...mapGetters('examenAspirante', ['getPermisoCamara', 'getPermisoScreen']),
		...mapGetters('examenAspirante', {
			getExamenAspiranteLoading: 'getLoading'
		}),
		finalizoExamen() {
			return (
				(!this.sinExamenAsignado &&
					!!this.getExamen &&
					!!this.getExamen.areasDeConocimientos &&
					this.getExamen.areasDeConocimientos.flatMap((x) => x.secciones)
						.length > 0 &&
					this.getExamen.areasDeConocimientos
						.flatMap((x) => x.secciones)
						.filter((x) => x.terminada === false).length === 0) ||
				this.examenFinalizado
			);
		},
		permisoGrabar() {
			if (this.getEnableCameraRecorder && this.getEnableScreenRecorder) {
				return this.getPermisoCamara && this.getPermisoScreen;
			} else if (this.getEnableCameraRecorder) {
				return this.getPermisoCamara;
			} else if (this.getEnableScreenRecorder) {
				return this.getPermisoScreen;
			}
			return true;
		}
	},
	created() {
		this.ESTA_EN_INICIO({});
	},
	mounted: function() {
		// this.openConnection();
		this.establecerAreaDeConocimiento('Inicio');
		this.establecerSeccion('');
		this.establecerSiguienteSeccion('');
		this.InitExamen({
			ficha: this.oidcUser.username,
			onComplete: (resposeEstructura) => {
				const {
					nombre,
					introduccion,
					fechaYHoraInicio,
					examenIniciado,
					examenFinalizado,
					totalPreguntas
				} = resposeEstructura.data.data;
				this.examenFinalizado = examenFinalizado;
				this.examenIniciado = examenIniciado;
				this.nombreExamen = nombre;
				this.introduccionExamen = introduccion;
				this.fechaYHoraInicio = moment(fechaYHoraInicio).format(
					'YYYY/MM/DD HH:mm'
				);
				this.fechaInicioLetras = moment(fechaYHoraInicio)
					.locale('es')
					.format('DD/MMMM/YYYY HH:mm');
				// this.iniciar();
				this.totalPreguntas = totalPreguntas;
				setTimeout(this.EstadoExamen, 400);
			},
			onError: () => {
				this.sinExamenAsignado = true;
				setTimeout(this.EstadoExamen, 400);
			}
		});
		this.obtenerElemento({
			ficha: this.oidcUser.username,
			onComplete: (response) => {
				const { aceptoTerminosYCondiciones } = response.data.data;
				this.aceptoTerminosYCondiciones = aceptoTerminosYCondiciones;
			}
		});
		// this.iniciar();
	},
	methods: {
		...mapActions('app', [
			'establecerAreaDeConocimiento',
			'establecerSeccion',
			'establecerSiguienteSeccion'
		]),
		...mapActions('examenAspirante', ['siguiente', 'obtenerDatosConstancia']),
		...mapActions('aspirantes', [
			'obtenerElemento',
			'actualizarTerminosYCondiciones'
		]),
		...mapActions('sidebar', ['InitExamen']),
		...mapActions('constancias', ['obtenerConstancia']),
		...mapActions('examenhub', [
			'iniciar',
			'openConnection',
			'SaltoPregunta',
			'EstadoExamen'
		]),
		...mapMutations('examenAspirante', ['ESTA_EN_INICIO']),
		iniciarExamen() {
			this.siguiente({
				ficha: this.oidcUser.username,
				onComplete: (resposeDatos) => {
					// if (this.getEnableFullScreen) this.putFull();
					this.$router.push('areaDeConocimiento');
				}
			});
			// this.iniciar();
		},
		putFull() {
			if (screenfull.isEnabled) {
				screenfull.request();
			}
		},
		actualizarPoliticas() {
			const params = {
				aceptoTerminosYCondiciones: true,
				fechaTerminosYCondiciones: moment().format('YYYY/MM/DD HH:mm')
			};
			this.actualizarTerminosYCondiciones({
				ficha: this.oidcUser.username,
				params: params,
				onComplete: () => {
					this.$refs.modalPolitica.close();
					this.iniciarExamen();
				}
			});
		},
		handleIniciar() {
			if (!this.aceptoTerminosYCondiciones) {
				this.$refs.modalPolitica.toggle();
			} else {
				if (!this.permisoGrabar)
					return Notification(
						'error',
						'Favor de dar permiso de grabación para continuar con la realización del examen'
					);
				if (this.examenIniciado && !this.examenFinalizado) {
					return this.$router.push('areaDeConocimiento');
				}
				this.iniciarExamen();
			}
		},
		onResultados() {
			this.$router.push('resultados');
		},
		onConstancia() {
			this.obtenerDatosConstancia({
				ficha: this.oidcUser.username,
				onComplete: (res) => {
					const link = document.createElement('a');
					link.href = window.URL.createObjectURL(res.data);
					link.download = `constanciaExamen_${this.oidcUser.username}.pdf`;
					link.click();
				},
				onError: (error) => {
					console.log('onError ->>> ', error);
				}
			});
		}
	}
};
</script>
